"use client";
import * as React from 'react';
import { ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface FreeDisclosureProps extends Omit<React.HTMLAttributes<HTMLDivElement>,'title'> {
  title:React.ReactNode;
  right?:React.ReactNode;
  summary?:React.ReactNode;
  expanded?:boolean;
  onExpandedChange?:(expanded:boolean)=>void;
  defaultExpanded?:boolean;
  disabled?:boolean;
}
export function FreeDisclosure({title,right,summary,expanded,onExpandedChange,defaultExpanded=true,disabled,children,className,...props}:FreeDisclosureProps){
  const [local,setLocal]=React.useState(defaultExpanded);
  const open=expanded??local;
  const id=React.useId();
  return <div data-slot="freeui-disclosure" data-expanded={open} className={cn('freeui-disclosure',className)} {...props}><div className="freeui-disclosure-header"><button type="button" aria-expanded={open} aria-controls={id} disabled={disabled} onClick={()=>{if(expanded===undefined)setLocal(!open);onExpandedChange?.(!open);}}><ChevronRight size={13}/><span>{title}</span>{!open&&<span className="freeui-disclosure-summary">{summary}</span>}</button>{right&&<div className="freeui-disclosure-actions">{right}</div>}</div><div id={id} className="freeui-disclosure-body" hidden={!open}>{children}</div></div>;
}
export const FreeDisclosureGroup=FreeDisclosure;
